import { reaction } from 'mobx';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { IBaseNoteAreaService, IBaseNoteAreaServiceDelegates, IBaseNoteAreaViewerService } from '@src/slide/application/service/note-area-component/core/base/base-note-area-service.interface';
import BaseViewService from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-service';
import BaseNoteAreaModel from '@src/slide/application/service/note-area-component/core/base/base-note-area-model';
import BaseViewModel from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-model';
import { NOTE_REF_NAME } from '@src/framework/frame/components/note-area/constant';

export default abstract class BaseNoteAreaService<P extends {}> extends BaseViewService<P>
    implements IBaseNoteAreaService {
    declare protected services?: IBaseNoteAreaServiceDelegates;
    declare protected model: BaseNoteAreaModel<P>;

    public setViewerServiceDelegates(services: IBaseNoteAreaViewerService) {
        this.services = {
            ...this.services,
            ...services,
        };
    }

    public componentDidMount(): void {
        this.viewDelegate?.disposeOnUnmount(reaction(() => this.services?.selectionService?.currentSlideIndex, () => {
            this.viewDelegate?.forceRender();
        }));
    }

    /**
     * 关闭note的数据方法（非ui）
     */
    public hideNote = () => {
        const slide = this.services?.selectionService?.currentSlide;
        const shapeModel = slide?.noteData?.noteTextBody;
        shapeModel?.editorInstance?.triggerBlur?.({ needUpdate: true });
        this.services?.noteAreaManager?.setHide();
    };

    public getNoteModel = () => {
        const currentSlide = this.services?.selectionService?.currentSlide;
        if (!currentSlide) return null;
        return currentSlide.noteData;
    };

    public getEditable = () => this.services?.userPriviledgeService?.pptEditorState === PPTEditorStateType.EDITABLE;

    public getNoteAreaInfo = () => ({
        noteAreaHeight: this.model.noteAreaHeight,
    });

    protected createViewModel(): BaseViewModel<{}> {
        return new BaseNoteAreaModel();
    }

    protected get noteCanvasRef(): HTMLCanvasElement | undefined {
        return this.viewDelegate?.getElementById(NOTE_REF_NAME.NOTE_CANVAS);
    }

    protected get noteContainerRef(): HTMLDivElement | undefined {
        return this.viewDelegate?.getElementById(NOTE_REF_NAME.NOTE_CONTAINER);
    }

    protected get noteTopDivRef(): HTMLDivElement | undefined {
        return this.viewDelegate?.getElementById(NOTE_REF_NAME.NOTE_TOP);
    }

    protected get noteBottomDivRef(): HTMLDivElement | undefined {
        return this.viewDelegate?.getElementById(NOTE_REF_NAME.NOTE_BOTTOM);
    }
}
